import React, { memo } from "react";
import { Tab, TabProps } from "@material-ui/core";
import useAppTab from "./index.hooks";
import cn from "classnames";

type AppTabProps = {
  error?: boolean;
} & TabProps;

const AppTab = ({ error, ...props }: AppTabProps) => {
  const { styles, classes, atomicStyles } = useAppTab();

  return (
    <Tab
      className={cn(styles.default, error ? styles.error : null)}
      {...props}
    />
  );
};

export default memo(AppTab);
